import gql from 'graphql-tag'

export const mutation = gql`
  mutation deleteRole($id: Int!) {
    record: delete_roles_by_pk(id: $id) {
      id
    }
  }
`

export default mutation
